

import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/forms/form17";
const form17State = namespace("Form17");

import { form17DataInfoType } from '@/types/Information/Form17';
import {getPartyTitles} from '../PartyTitlesForm17';
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";

@Component({
    components:{       
        UnderlineForm         
    }
})
export default class Form17Layout extends Vue {

    @Prop({required:true})
    result!: form17DataInfoType; 

    @form17State.Action
    public UpdateForm17Info!: (newForm17Info: form17DataInfoType) => void
    
    dataReady = false;
    applicantNames: string[] = [];
    respondentNames: string[] = [];
    
    applicantNamesFull='';
    respondentNamesFull='';
    allowedCostsParties='';
    payingParties = '';
    
    
    appearingAppellants =[]
    appearingRespondents =[]

    mounted(){
        // this.dataReady = false;
        //console.log(this.result)
        this.extractInfo();       
        this.dataReady = true;
    }
   
    public extractInfo(){        
       
        this.applicantNames = [];
        this.respondentNames = [];        

        for (const resInx in this.result.respondents){
            const fullTitle = getPartyTitles(this.result.respondents[resInx],' ')
            this.respondentNames.push(fullTitle);
        }
        this.respondentNamesFull = this.combineNames(this.result.respondents, '', this.respondentNames)
      

        for (const appInx in this.result.appellants){
            const fullTitle = getPartyTitles(this.result.appellants[appInx],' ')
            this.applicantNames.push(fullTitle);            
        }
        this.applicantNamesFull = this.combineNames(this.result.appellants, '', this.applicantNames)
        
        this.payingParties = this.result.payingCostsParties.join(', ')
        this.allowedCostsParties = this.result.allowedCostsParties.join(', ') 
    }
    

    public combineNames(names, nameField?, addingNameArray?){
        let namesString = ''
        const numberOfNames = names.length       
        for(const index in names){
            let addingName=''
            if(addingNameArray?.length>0){
                addingName=addingNameArray[index]
            }
            else if(nameField)
                addingName = names[index][nameField] 
            else
                addingName = names[index]

            if(Number(index)>0 && Number(index)+1 == numberOfNames)
                namesString += ' and '+addingName
            else if(Number(index)==0)
                namesString += addingName
            else
                namesString += ', '+addingName
        }
        return namesString
    }
    
}

